import React, {Fragment, useState, useEffect} from 'react'
import { useHistory, useLocation, useParams, Link } from 'react-router-dom'
import axios from 'axios';
import Swal from 'sweetalert2'
import { Cabecera } from '../components/Cabecera';
import { Footer } from '../components/Footer';
import { EventosUsuario } from '../components/EventosUsuario';




export const EditaPerfilusuario = (props) => {
    
   

    const history = useHistory();
    const location = useLocation();
    

    const [messageLogin, setmessageLogin] = useState('');
    const messageLoginChange = (val) => {
        setmessageLogin(val)
    }

    const [formIsInvalid, setformIsInvalid] = useState(false);
    const formIsInvalidChange = (val) => {
        setformIsInvalid(val)
    }

    const valorSectores = [
        {id:'Hostelería', title:'Hostelería'},
        {id:'Comercio', title:'Comercio'},
        {id:'Agricultura, ganadería, pesca', title:'Agricultura, ganadería, pesca'}, 
        {id:'Transporte y logística', title:'Transporte y logística'},
        {id:'Asesoría', title:'Asesoría'},
        {id:'Gestoría', title:'Gestoría'},
        {id:'Construcción', title:'Construcción'},
        {id:'Industria ', title:'Industria '},
        {id:'Instalaciones y mantenimientos', title:'Instalaciones y mantenimientos'},
        {id:'Otros', title:'Otros'}
    ]

    const [nombreData, setNombreData] = useState(null);
    const nombreChange = (val) => {
        setNombreData(val.target.value)
    }

    const [apellidosData, setApellidosData] = useState(null);
    const apellidosChange = (val) => {
        setApellidosData(val.target.value)
    }

    const [provinciaData, setProvinciaData] = useState(null);
    const provinciaChange = (val) => {
        setProvinciaData(val.target.value)
    }

    const [sectorData, setSectorData] = useState(null);
    const sectorChange = (e) => {
        setSectorData(e.target.value)
    }

    const [listSettings, setSettings] = useState(false);
    const fetchSettings = async () => {
        
        try {
           
        let axiosConfig2 = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':`Bearer ${localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-token`)}`
              },  
          };
          await axios.get(`${process.env.REACT_APP_URL_API}usuarios/${localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-idu`)}`,axiosConfig2)
          .then(result => {
            console.log('entra2',result.data.data)
            setNombreData(result.data.data.nombre)
            setApellidosData(result.data.data.apellidos)
            setProvinciaData(result.data.data.provincia)
            setSectorData(result.data.data.departamento)
            setSettings(result.data.data)
          })
       
        } catch (error) {
           console.log('error',error)
        }
    };
  
    useEffect(() => {
        fetchSettings();
    },[]);

    const gotoUpdate = async () => {

        try {
            var dataForm = {
                "idUsuario":localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-idu`),
                "nombre":nombreData,
                "apellidos": apellidosData,
                "provincia": provinciaData,
                "departamento": sectorData,
                "email": localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-email`),
                "usuario":localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-nombre`),

            }
            let axiosConfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':`Bearer ${localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-token`)}`
                  },  
              };
            await axios.put(`${process.env.REACT_APP_URL_API}usuarios/InscribirseModif`, dataForm, axiosConfig)
            .then(resLogin => {
                if(resLogin.status === 200){
                    if(resLogin.data === 'error'){
                        messageLoginChange('El formulario contiene errores')
                    }else{
                          Swal.fire({
                            title: '',
                            text: `Perfil de usuario actualizado`,
                            icon: 'success',
                            showCancelButton: false,
                            confirmButtonColor: '#42A72C',
                            cancelButtonColor: '#E5324B', 
                            confirmButtonText: 'Aceptar',
                            cancelButtonText: 'Cancelar'
                         }).then((result) => {
                            if(result.value){
                                
                           }
                         })
                   
                    }
                }else{
                    messageLoginChange('El formulario contiene errores')
                }

            })
              
        } catch (error) {
            //setloaddata(false);
            messageLoginChange('El formulario contiene errores') 
            formIsInvalidChange(true)
        }
    }

      
    if(!listSettings) return(<div></div>)
    return(
        <Fragment>
            <Cabecera imagen={false} top={false} removeAuth={props.removeAuth} />
            <div id="perfilcontain" className="container">
                <div className="row">
                    
                    <div className="col-lg-12 col-md-12">
                        <h2>Configuración</h2>
                        <p className="form-text text-muted">Modificar tu perfil</p>
                        <hr/>
                        <form className="form" onSubmit={(e) =>{ e.preventDefault(); gotoUpdate()}}>
                                    <h5>Mis datos profesionales</h5>
                                    <div class="row">
                                        <div class="col">
                                            <div className="form-group mb-2 mr-sm-2">
                                                <label for="nombre">Nombre</label>
                                                <input className={formIsInvalid ? 'form-control is-invalid' : 'form-control'}  type="text" id="nombre" name="nombre" placeholder="Nombre*" required  onChange={ nombreChange } value={nombreData} /><br/>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div className="form-group mb-2 mr-sm-2">
                                                <label for="apellidos">Apellidos</label>
                                                <input className={formIsInvalid ? 'form-control is-invalid' : 'form-control'}  type="text" id="apellidos" name="apellidos" placeholder="Apellidos*" required  onChange={ apellidosChange } value={apellidosData} /><br/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <div className="form-group mb-2 mr-sm-2">
                                                <label for="provincia">Provincia</label>
                                                <input className={formIsInvalid ? 'form-control is-invalid' : 'form-control'}  type="text" id="provincia" name="provincia" placeholder="Provincia*" required  onChange={ provinciaChange } value={provinciaData} /><br/>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div className="form-group mb-2 mr-sm-2">
                                                <label for="sector">Sector</label>
                                                <select class="form-control"  onChange={(e) =>  sectorChange(e)} value={sectorData}>
                                                    <option value='-1'>Sector</option>
                                                    {
                                                        
                                                        valorSectores.map(item => 
                                                            <option selected={listSettings.departamento == item.id && 'selected' }  key={`cat-${item.id}`} value={item.id}>{item.title}</option>
                                                        )
                                                    }
                                                    
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <hr/>
                                    <p className="form-text text-muted">*campos obligatorios</p>
                                    <div class="row justify-content-md-center">
                                        <div class="col col-md-2">
                                            <div className="form-group">
                                                <Link className="btn btn-light btn-form" to="/">Cancelar</Link>
                                            </div>
                                        </div>
                                        <div class="col col-md-3">
                                            <div className="form-group">
                                                <button className="btn btn-primary btn-form" type="submit">Guardar cambios</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <hr/>
                    </div>	
                </div>
                <EventosUsuario />			
            </div>
            
            <Footer />
        </Fragment>
    )

}